import { IRootState } from '../../../store'
import { ICrewMemberList } from '../store/crew.types'

export const getCrewListSelector = (state: IRootState): ICrewMemberList => state.crew.crewList
